import { createContext, useContext, useEffect, useRef, useState } from "react";
import { useApi } from "@/lib/api";

const RadioContext = createContext(null);
const STREAM_URL = process.env.REACT_APP_RADIO_STREAM_URL;

export const RadioProvider = ({ children }) => {
  const audioRef = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [loading, setLoading] = useState(false);
  const [volume, setVolume] = useState(0.8);
  const { data, refetch } = useApi("/radio/now-playing");

  useEffect(() => {
    const t = setInterval(() => refetch(), 30000);
    return () => clearInterval(t);
  }, [refetch]);

  useEffect(() => {
    if (audioRef.current) audioRef.current.volume = volume;
  }, [volume]);

  const toggle = async () => {
    const audio = audioRef.current;
    if (playing) {
      audio.pause();
      audio.src = "";
      setPlaying(false);
      return;
    }
    setLoading(true);
    audio.src = STREAM_URL;
    try {
      await audio.play();
      setPlaying(true);
    } catch (e) {
      setPlaying(false);
    } finally {
      setLoading(false);
    }
  };

  const current = data?.track ? { artist: data.artist, title: data.track, cover: data.cover, buy_link: data.buy_link } : null;

  return (
    <RadioContext.Provider value={{ playing, loading, toggle, volume, setVolume, nowPlaying: data?.title, cover: data?.cover, current }}>
      {children}
      <audio ref={audioRef} preload="none" data-testid="radio-audio-element" />
    </RadioContext.Provider>
  );
};

export const useRadio = () => useContext(RadioContext);
